import { Cascader } from 'antd'
import React, { Dispatch, SetStateAction, useMemo } from 'react'
import styled from 'styled-components'

export type TwoStepFieldSelectOption = {
  label: string
  value: string
}

export type TwoStepDropdownProps = {
  primaryOptions: ReadonlyArray<TwoStepFieldSelectOption>
  secondaryOptions: ReadonlyMap<string, ReadonlyArray<TwoStepFieldSelectOption>>
  primarySelection: string
  setPrimarySelection: Dispatch<SetStateAction<string>>
  secondarySelection: string
  setSecondarySelection: Dispatch<SetStateAction<string>>
  placeholder?: string
  width?: React.CSSProperties['width']
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`

export const TwoStepDropdown: React.FC<TwoStepDropdownProps> = ({
  primaryOptions,
  secondaryOptions,
  primarySelection,
  setPrimarySelection,
  secondarySelection,
  setSecondarySelection,
  placeholder = 'Select an option',
  width = '500px',
}) => {
  const cascaderOptions = useMemo(
    () =>
      primaryOptions.map((primary) => ({
        label: primary.label,
        value: primary.value,
        children: (secondaryOptions.get(primary.value) || []).map((sec) => ({
          label: sec.label,
          value: sec.value,
        })),
      })),
    [primaryOptions, secondaryOptions]
  )

  const cascaderValue = useMemo(() => {
    if (!primarySelection || !secondarySelection) return []
    return [primarySelection, secondarySelection]
  }, [primarySelection, secondarySelection])

  const handleChange = (value: string[]) => {
    if (value.length === 2) {
      setPrimarySelection(value[0])
      setSecondarySelection(value[1])
    } else if (value.length === 1) {
      setPrimarySelection(value[0])
      setSecondarySelection('')
    } else {
      setPrimarySelection('')
      setSecondarySelection('')
    }
  }

  return (
    <InputContainer>
      <Cascader
        options={cascaderOptions}
        value={cascaderValue}
        onChange={handleChange}
        placeholder={placeholder}
        style={{ width }}
      />
    </InputContainer>
  )
}
